module.exports = __webpack_public_path__ + "media/images/Trash-2-outline-red-6e2c8ea9.svg";